module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.SitePage_Login":{"widgets.loginForm.container":[{"value":".loginform_container","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107004},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.loginError.event":[{"value":"loginError","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107007},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.loginError.widget":[{"value":"@root","lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107008},"path":"~.SitePage_Login","_fox_":1}],"widgets.loginForm.handleWom.loginError.callback":[{"value":function(response) {
var alias = null;
var txt = response.reason;
var code = response.code;
var container = $(fox.wom.selectFirst('~#loginForm').element[0]);
var inp;
var erase = false;
if (code == 2001 || code == 43) {
alias = 'le';
}
if (code == 3|| code == 33) {
alias = 'captcha';
erase = true;
}
if (code == 4 || code == 44) {
alias = 'password';
erase = true;
}
if (code == 2 || code == 6) {
this.showDefaultErrorBlock();
this.hideErrorBlock();
return;
}
input = container.find('[name="le"]')
input.parent().addClass('error').next().text(txt).addClass('show');
this.hideDefaultErrorBlock();
},"lWeight":true,"desc":{"level":7,"weightDesc":[],"weight":107040},"path":"~.SitePage_Login","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/login.js
// module id = 1033
// module chunks = 4